import {
  Shield,
  MonitorHeartOutlined,
  AccountBalanceOutlined,
  Diversity1Outlined,
  SpaOutlined,
  CopyrightOutlined,
  QuestionMarkOutlined,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { ComponentType } from 'react';

import { CaclRiskScore } from '@/generated/gql/graphql';
import { riskScoreToLevel } from '~/routes/experiments/RiskSustainability/widgets/SupplierRiskScoreWidget';

const iconMap: Record<string, ComponentType<SvgIconProps>> = {
  'd1054f59-5aeb-4532-b011-27b0f624075e': Shield,
  '4a4985f4-0b07-4e8d-89fb-2f224062d8bf': MonitorHeartOutlined,
  '0b3d2144-48ff-4b1d-b40a-c684b4ab59a0': AccountBalanceOutlined,
  'bca5d88a-5ab3-4fe7-bc94-09b547e62e6a': Diversity1Outlined,
  '8e17f1b0-8189-4e9c-b8ff-5b9cfbaa1978': SpaOutlined,
  'df65f8e6-2fc5-4a3d-bd1e-986f84e20a37': CopyrightOutlined,
};

interface IconProps extends SvgIconProps {
  id: string;
  score: CaclRiskScore;
}

export const RiskCategoryIcon = ({ id, score, ...props }: IconProps) => {
  const IconComponent = iconMap[id];
  return IconComponent ? (
    <IconComponent color={riskScoreToLevel[score]} {...props} />
  ) : (
    <QuestionMarkOutlined color={riskScoreToLevel[score]} {...props} />
  );
};
